module.exports = __webpack_public_path__ + "static/media/PPM_white.5d9938f6.png";